export default __webpack_public_path__ + "locales/lv/FillPDFDialog.json?hash=868e3be80368b9b7638db0e1ce34c8be";